// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import VueNoty from 'vuejs-noty'
import VeeValidate from './services/Validator'
import VueMask from 'v-mask'
import YaMetrika from '@/services/YaMetrika'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'font-awesome/css/font-awesome.css'
import 'vuejs-noty/dist/vuejs-noty.css'

Vue.config.productionTip = false

Vue.use(VueMask)
Vue.use(VueResource)
Vue.use(BootstrapVue)
Vue.use(VueNoty, {
  timeout: 4000,
  theme: 'relax',
  closeWith: ['click'],
  layout: 'bottomRight'
})

Vue.use(VeeValidate, {
  locale: 'ru',
  fieldsBagName: 'errorFields'
})

if (process.env.NODE_ENV === 'development') {
  Vue.http.options.root = 'http://guide-portal-back.loc'
} else {
  Vue.use(YaMetrika, { id: 45740148 })

  router.afterEach((to, from, next) => {
    const counter = Vue.prototype.$getYaCounter()
    if (counter) {
      counter.hit(to.fullPath)
    }
  })
}

Vue.http.options.emulateJSON = true
Vue.http.interceptors.push((request, next) => {
  request.headers.set('Authorization', localStorage.getItem('token'))
  next()
  // next((response) => {
  //   if (!response.ok && response.status === 401 && response.data.message) {
  //     Vue.$noty.error(response.data.message)
  //   }
  // })
})

router.beforeEach((to, from, next) => {
  setTimeout(() => {
    window.scrollTo(0, 0)
  }, 200)
  // store.dispatch('checkAuth')
  if (to.matched.some(record => record.meta.requiresAuth) && !store.getters.isAuth) {
    next({name: 'Home'})
  } else if (to.name === 'Login' && store.getters.isAuth) {
    next({name: 'UserProfile'})
  } else {
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js